import { useCallback } from "react";
import Cookies from "js-cookie";
import { useFormRenderingContext } from "../contexts/FormRenderingContext";

const COOKIE_PREFIX = "circle_modal_form_closed";

const cookieName = (formUid: string) => `${COOKIE_PREFIX}_${formUid}`;

const setCookie = (formUid: string, days: number): void => {
  // this will only work on secure (https) environments
  Cookies.set(cookieName(formUid), "true", {
    expires: days,
    sameSite: "None",
    secure: true,
  });
};

const checkCookie = (formUid: string): boolean =>
  Cookies.get(cookieName(formUid)) !== undefined;

export const useModalCookie = () => {
  const { form, popupFrequency } = useFormRenderingContext();
  const shouldSuppressPopupForm = checkCookie(form.uid);

  const suppressPopupForm = useCallback(() => {
    if (popupFrequency === 0) return;
    setCookie(form.uid, popupFrequency);
  }, [form.uid, popupFrequency]);
  return { shouldSuppressPopupForm, suppressPopupForm };
};
